import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-refer-dashboard',
  templateUrl: './refer-dashboard.component.html',
  styleUrls: ['./refer-dashboard.component.css']
})
export class ReferDashboardComponent implements OnInit {
  public email: any;
  public ur_name: any;
  public referrals_name: any;
  public referrals_email: any
  public referrals_Phone: number;
  public referrals_comments: any;
  ramki: any;

  constructor(public usr: UserService,
    public toastr: ToastrService,
    public router: Router,
    private SpinnerService: NgxSpinnerService) {
    let b = JSON.parse(localStorage.getItem('data'));
    this.ramki = b;
  }

  ngOnInit(): void {
  }
  
  referClose()
  {
    setTimeout(() => {
      this.router.navigate(['dashboard']);
    }, 100);
  }
  registerFunction() {
    if (!this.ur_name) {
      return this.toastr.error("Your Name is Empty");
    } else if (!this.referrals_name) {
      return this.toastr.error("Referral's Name is Empty");
    } else if (!this.referrals_email) {
      return this.toastr.error("Referral's Email is Empty")
    } else if (!this.referrals_Phone) {
      return this.toastr.error("Phone is Empty");
    } else if (!this.referrals_comments) {
      return this.toastr.error("Comment section is empty");
    } else {
      let obj = {
        'email': this.ramki.email,
        'ur_name': this.ur_name,
        'referrals_name': this.referrals_name,
        'referrals_email': this.referrals_email,
        'referrals_Phone': this.referrals_Phone,
        'referrals_comments': this.referrals_comments
      }
      this.SpinnerService.show();
      this.usr.refer(obj).subscribe((res: any) => {
        if (res.code === 200) {
          this.SpinnerService.hide(); 
          this.toastr.success(res.message);
          this.router.navigate(['dashboard']);
        } else {
          this.SpinnerService.hide();
          this.toastr.error(res.message)
        }
      }, (err) => {
        this.SpinnerService.hide();
        this.toastr.error(err);
      });
    }
  }
}
